export default "/images/c944404b21da7f938e52dae7d4eef6d4.avif";